import { catchErrorInto, effect, Entity, exhaustMapWithTrailing, fromPromise, LiveData, onComplete, onStart } from '@toeverything/infra';
import type { WorkspaceService } from '../../workspace';
import type { WorkspaceTeamsStore } from '../stores/teams';
import { EMPTY, map, mergeMap } from 'rxjs';


export class MyTeamIds extends Entity {
  constructor(
    private readonly store: WorkspaceTeamsStore,
    private readonly workspaceService: WorkspaceService
  ) {
    super();
  }

  ids$ = new LiveData<string[] | undefined>(undefined);



  readonly revalidate = effect(
    map(() => this.workspaceService.workspace.id),
    exhaustMapWithTrailing(workspaceId => {
      return fromPromise(async signal => {
        return this.store.myTeamIds(
          workspaceId,
          signal
        );
      }).pipe(
        mergeMap(data => {
          this.ids$.setValue(data);
          return EMPTY;
        }),
      );
    })
  );

  override dispose(): void {
    this.revalidate.unsubscribe();
  }

}